import { pseudoTagStringFromGQL, pseudoTagStringToGQL } from 'utils/coercionUtils';
import {
  DEFAULT_OPTIN_CHECKBOX_TEXT,
  DEFAULT_OPTIN_DISCLAIMER,
  FIELD_TYPES,
  OPTIN_FORMATS,
  OPTIN_RADIO_DEFAULTS,
} from 'utils/constants';

function fromGQL(obj) {
  const { value, ...returnableField } = obj;

  // Legacy format: field was stored as radiobutton {options, defaultOption}
  // Migrate to default optInData structure
  if (value && value.options) {
    return {
      ...returnableField,
      type: FIELD_TYPES.BOOLEAN_OPT_IN,
      editors: {
        optInData: {
          checkboxText: DEFAULT_OPTIN_CHECKBOX_TEXT,
          disclaimer: DEFAULT_OPTIN_DISCLAIMER,
          hasCheckbox: true,
          hasDisclaimer: true,
          optInValue: returnableField.name,
          format: OPTIN_FORMATS.CHECKBOX,
          defaultChecked: false,
          defaultRadio: OPTIN_RADIO_DEFAULTS.NONE,
        },
      },
    };
  }

  // New format: already stored as opt-in value
  const optInData = { ...value };
  optInData.hasDisclaimer = optInData.disclaimer ? optInData.disclaimer.length > 0 : false;
  optInData.hasCheckbox = optInData.checkboxText ? optInData.checkboxText.length > 0 : false;
  optInData.optInValue = optInData.optInValue || returnableField.name;
  if (optInData.disclaimer) {
    optInData.disclaimer = pseudoTagStringFromGQL(optInData.disclaimer);
  } else {
    optInData.disclaimer = '';
  }
  if (optInData.checkboxText) {
    optInData.checkboxText = pseudoTagStringFromGQL(optInData.checkboxText);
  } else {
    optInData.checkboxText = '';
  }

  return {
    ...returnableField,
    type: FIELD_TYPES.BOOLEAN_OPT_IN,
    editors: {
      optInData: { ...optInData },
    },
  };
}

function toGQL(obj) {
  const { editors } = obj;
  const { optInData } = editors;
  const { hasDisclaimer, hasCheckbox, ...valueObj } = optInData;

  valueObj.disclaimer = hasDisclaimer ? pseudoTagStringToGQL(optInData.disclaimer) : '';
  valueObj.checkboxText = hasCheckbox ? pseudoTagStringToGQL(optInData.checkboxText) : '';
  valueObj.optInValue = optInData.optInValue || obj.name;

  return {
    value: valueObj,
    name: obj.name,
  };
}

export default { fromGQL, toGQL };
